import React, { ReactElement, useEffect } from 'react';
import { Button } from 'idsk-react-components';
import { ConfirmModal } from 'slovlex-idsk-react-components';
import { useClient, useClientStatusContext } from '../../../../../context/ClientStatusContext';
import { useSuccessMessageContext } from '../../../../../context/SuccessMessageContext';
import Tezaurus from '../../../../../model/Tezaurus';
import { deleteTezaurus } from '../../../../../client/tezaurus/tezaurusDeleteClient';
import { technickePricinyErrorStatus } from '../../../../../constants/ErrorConstant';

interface Props {
  tezaurus: Tezaurus;
  reloadTezaurusList():void;
}

const TezaurusDeleteConfirmModal = ({
  tezaurus,
  reloadTezaurusList,
}: Props): ReactElement => {
  const { displaySuccess } = useSuccessMessageContext();
  const {
    wrapClient: deleteTezaurusClient,
    status: deleteTezaurusStatus,
  } = useClient(deleteTezaurus);
  const { handleStatus } = useClientStatusContext();

  const handleDeleteTezaurus = async (): Promise<void> => {
    await deleteTezaurusClient(tezaurus.uuid);
    reloadTezaurusList();
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  useEffect(() => {
    if (deleteTezaurusStatus?.responseCode === 404) {
      handleStatus(technickePricinyErrorStatus);
    }
  }, [deleteTezaurusStatus, handleStatus]);

  return (
    <ConfirmModal
      question={`Naozaj si prajete zmazať tezaurus "${tezaurus.nazov}"?`}
      description={'Táto akcia zároveň zmaže aj všetky termíny, ktoré daný tezaurus obsahuje!'
       + ' Tieto termíny už nebude možné obnoviť. '}
      cancelButtonText="Zrušiť"
      confirmButton={
        (
          <Button buttonStyle="negative" size="large">Zmazať</Button>
        )
      }
      openButton={(
        <Button size="small" buttonStyle="link-negative">Zmazať</Button>
      )}
      doAfterConfirm={handleDeleteTezaurus}
    />
  );
};

export default TezaurusDeleteConfirmModal;
